import { Injector } from '@angular/core';
import { BaseWidgetProperties, ActionButtonOutcomesType } from '@finxone-platform/shared/sys-config-types';
import { InvitationService } from '../../../services/invitation-service/invitation.service';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { handleRedirection } from '../cta-redirection.utils';
import { AlertHandlerService } from '@finxone-platform/shared/services';

export function declineJointAccountRequest(injector: Injector, widgetProperties: BaseWidgetProperties): void {
  const invitationService = injector.get(InvitationService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const alertHandlerService = injector.get(AlertHandlerService);

  const ctaAction = widgetProperties.buttonActionType as string;
  const invitationToken = sessionStorage.getItem('jointAccountInvitationToken');
  const actionNavigationConfigurations = widgetProperties.actionNavigationConfigurations;

  if (!invitationToken) {
    console.error('Invitation token not found');
    return;
  }

  ctaButtonSignalService.setSignal({ [ctaAction]: false });

  invitationService.declineInvitation(invitationToken).subscribe({
    next: () => {
      sessionStorage.removeItem('jointAccountInvitationId');
      sessionStorage.removeItem('jointAccountInvitationToken');
      ctaButtonSignalService.setSignal({ [ctaAction]: true });
      if (actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS]) {
        handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true, false);
      } else {
        alertHandlerService.showAlertFn('success', 'Joint account invitation declined successfully');
      }
    },
    error: (error) => {
      console.error('Error declining joint account invitation:', error);
      ctaButtonSignalService.setSignal({ [ctaAction]: true });
      if (actionNavigationConfigurations?.[ActionButtonOutcomesType.FAILURE]) {
        handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.FAILURE, true, false);
      } else {
        alertHandlerService.showAlertFn('error', 'Failed to decline joint account invitation');
      }
    },
  });
}
